import React from 'react'

import { IntegrationServiceId } from '../../../common/integrations'
import { useZocksQuota } from '../../../components/ScopedBlock/hooks'
import { BoxDocumentIntelligenceUpsellBanner } from './BoxDocumentIntelligenceUpsellBanner'

const INTEGRATION_UPSELLS: Partial<Record<IntegrationServiceId, { quota: string; Banner: React.FC }>> = {
  [IntegrationServiceId.BOX]: { quota: 'ai.documentSummaryAgent.value', Banner: BoxDocumentIntelligenceUpsellBanner },
}

interface IntegrationUpsellBannerProps {
  serviceId: IntegrationServiceId
}

export const IntegrationUpsellBanner: React.FC<IntegrationUpsellBannerProps> = ({ serviceId }) => {
  const { hasQuota, quotaSuccess } = useZocksQuota()
  const upsell = INTEGRATION_UPSELLS[serviceId]
  if (!upsell || !quotaSuccess) {
    return null
  }
  const hasUpsellQuota = hasQuota(upsell.quota)
  if (hasUpsellQuota) {
    return null
  }

  return (
    <div className='w-75 mw-800 mt-4'>
      <upsell.Banner />
    </div>
  )
}
